import browser from '@wetransfer/transfer/modules/concorde-browser/browser';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export default class ExperimentSendInstallBannerMweb {
  static key = 'send-install-banner-mweb';

  static variations = {
    control: 'control',
    'send-view': 'send-view',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isSendView(): boolean {
    return (
      this.currentVariant() === this.variations['send-view'] && browser.isMobile
    );
  }

  static currentVariant(): string {
    return getFullVariant(this.key, { value: this.variations.control })
      .value as string;
  }
}
